import { Box, CircularProgress } from '@mui/material';
import { DataGrid, GridColDef, gridPaginatedVisibleSortedGridRowIdsSelector, useGridApiRef } from '@mui/x-data-grid';
import { Shadow } from '../../types/Shadow.types'
import { hasReadAllShadows, hasReadShadow } from '../../services/machines/machinesApi'
import { useNavigate } from 'react-router-dom'
import { useMachinesContext } from '../../context/MachinesContext'
import { useSearch } from '../../hooks/useSearch'

const columns: GridColDef[] = [
    {
        field: 'instance',
        headerName: 'Instancja',
        // "…" while the value is still being read in the background.
        valueGetter: ({ row }) => (hasReadShadow(row, Shadow.Datasyncd) ? row.instance ?? '' : '…'),
        flex: 1,
    },
    {
        field: 'thingName',
        headerName: 'Numer seryjny',
        flex: 1,
    },
    {
        field: 'version',
        headerName: 'Wersja oprogramowania',
        type: 'number',
        flex: 1,
    },
    {
        field: 'lastUpdateString',
        headerName: 'Ostatnia aktualizacja',
        // The latest time across all shadows is final only once every shadow is read.
        valueGetter: ({ row }) => (hasReadAllShadows(row) ? row.lastUpdateString : '…'),
        description: 'This column has a value getter and is not sortable.',
        flex: 1,
    },
];

const MachinesList = () => {
    const navigate = useNavigate();
    const { machines, isLoading, setVisibleMachines } = useMachinesContext();
    const apiRef = useGridApiRef();
    const filteredMachines = useSearch(machines);

    const openMachineDetails = (selectedMachine: any) => {
        navigate(`/machineConfiguration/${selectedMachine.id}`)
    }

    // Display a loading indicator while fetching data
    if (isLoading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                }}
            >
                <CircularProgress />
            </Box>
        )
    }

    return (
        <Box>
            <Box sx={{ height: '100%', width: '100%' }}>
                <DataGrid
                    apiRef={apiRef}
                    // Rows on screen (page, sorting and search included) get their details loaded first.
                    onStateChange={() => setVisibleMachines(gridPaginatedVisibleSortedGridRowIdsSelector(apiRef).map(String))}
                    rows={filteredMachines}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 25,
                            },
                        },
                    }}
                    pageSizeOptions={[25]}
                    disableColumnSelector
                    disableRowSelectionOnClick
                    onRowClick={(rowData) => openMachineDetails(rowData)}
                    getRowId={(machine) => machine.thingName}
                    sx={{
                        backgroundColor: 'white',
                        border: 'none',
                        borderRadius: 0,
                        '.MuiDataGrid-cell:first-of-type': {
                            textIndent: 40,
                        },
                        '.MuiDataGrid-cell': {
                            fontSize: 16,
                        },
                        '.MuiDataGrid-columnHeader:first-of-type': {
                            textIndent: 40,
                        },
                        '.MuiDataGrid-columnHeaders': {
                            backgroundColor: '#F7F8F9',
                        },
                        '.MuiDataGrid-columnHeader': {
                            color: '#00000099',
                        },
                        '& .MuiDataGrid-row:hover': {
                            cursor: 'pointer',
                        },
                    }}
                    rowHeight={75}
                />
            </Box>
        </Box>
    )
}

export default MachinesList
